import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/audits')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/audits' || location.pathname === '/audits/') {
      throw redirect({ to: '/audits/network-audits/active' });
    }
  },
});
